angular.module('env.data.models.commentModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("CommentModel",
            {
                extend: ['BaseModel'],
                fields: {
                    customerVisible: {
                        type: RepresentationModelFieldTypes.BOOLEAN
                    },
                    userFullName: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    userId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    text: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    orderId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    orderItemId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    }
                }
            }
        );
    })

;